import { useQuery } from "@tanstack/react-query"
import { getBackofficeJobNamesQuery } from "modules/backoffice/lib/jobSearch/getBackofficeJobNamesQuery"

export function useGetBackofficeJobNamesQuery() {
  return useQuery(getBackofficeJobNamesQuery())
}
